import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal, Spin } from 'antd';
import { adminRequest } from '../api';
import SceneScreenplay from './SceneScreenplay';

export default function ScheduleScenePreview({ documentId, sceneUid, onClose }) {
  const [scene, setScene] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let live = true;
    setScene(null); setError('');
    adminRequest(`/admin/productions/${encodeURIComponent(documentId)}/breakdown`)
      .then(data => {
        if (!live) return;
        const found = data.scenes?.find(s => s.sceneKey === sceneUid);
        if (!found) { setError('This scene is no longer available in the screenplay.'); return; }
        setScene(found);
      }).catch(e => { if (live) setError(e.message || 'The scene preview could not be loaded.'); });
    return () => { live = false; };
  }, [documentId, sceneUid, attempt]);
  return <Modal open width={800} className="production-prototype pp-scene-preview-modal" title={scene ? `Scene Preview — Scene ${scene.number}` : 'Scene Preview'} focusTriggerAfterClose={false} onCancel={onClose} footer={<Button aria-label="Close scene preview" onClick={onClose}>Close</Button>}>
    {error ? <Alert type="error" message={error} action={<Button onClick={() => setAttempt(n => n + 1)}>Retry</Button>} /> : scene ? <SceneScreenplay scene={scene} /> : <div className="pp-sched-loading"><Spin /></div>}
  </Modal>;
}